var L = /* @__PURE__ */ ((E) => (E.ORANGE = "orange", E.BLUE = "blue", E.YELLOW = "yellow", E.GREEN = "green", E.RED = "red", E.PURPLE = "purple", E.NEUTRAL = "neutral", E.GREY = "grey", E.ROCHE_BLUE = "roche-blue", E.EXTRA_LIGHT_BLUE = "extra-light-blue", E.LIGHT_BLUE = "light-blue", E.NAVY = "navy", E.DARK_GREEN = "dark-green", E.BRIGHT_GREEN = "bright-green", E))(L || {});
export {
  L as RocheUIBadgeColor
};
